// Keys that hold per-user state (filters, table state, reports). Anything not listed or
// matching a prefix (e.g. general preferences like scrollId) is left untouched.
const USER_STORAGE_PREFIXES = ['___locache___/', 'persist:'];
const USER_STORAGE_KEYS = ['tableState', 'filteredItems'];

const isUserKey = (key) =>
  USER_STORAGE_KEYS.includes(key) || USER_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix));

// Removes per-user data (filters etc.) so it does not leak to the next user of this browser.
export const clearUserScopedStorage = () => {
  [window.localStorage, window.sessionStorage].forEach((storage) => {
    try {
      Object.keys(storage)
        .filter(isUserKey)
        .forEach((key) => storage.removeItem(key));
    } catch (error) {
      console.error(error);
    }
  });
};
